import React from 'react';
import renderHTML from 'react-render-html';
import CmsContentWrapper from "../../common/CmsContentWrapper";

const FaqQA = ({ qa }) => {
	return (
		<li className="faq-item">
			<h3 className="faq-question">
				<b>Q:</b> { renderHTML(qa.question) }
			</h3>
			<div className="faq-answer">
				<CmsContentWrapper html={qa.answer} />
				{/*{ renderHTML(qa.answer) }*/}
			</div>
		</li>
	);
};

export default FaqQA;


// WEBPACK FOOTER //
// ./src/pages/support/faqs/FaqQA.js